import { render, staticRenderFns } from "./DatasetInformation.vue?vue&type=template&id=538f6484&"
import script from "./DatasetInformation.vue?vue&type=script&lang=js&"
export * from "./DatasetInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports